export const loginUser = (user) => {
  console.log("user action: ",user );
    return {
      type: 'LOGIN_USER',
      payload: user,
    };
  };
  
  // Otras acciones relacionadas con las tareas
  